import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../index.css';
import './Footer.scss';
import Footerlogo from '../assets/logo-white.png';
import { FaFacebookF, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaTwitter } from "react-icons/fa";

function Footer() {
  const currentYear = new Date().getFullYear();
  const [totalViews, setTotalViews] = useState(null);

  useEffect(() => {
    fetch('/php-api/track_visit.php')  
      .then(res => res.json())
      .then(data => {
        if (data.totalViews !== undefined) {
          setTotalViews(data.totalViews);
        } else {
          setTotalViews('N/A');
        }
      })
      .catch(() => setTotalViews('N/A'));
  }, []);

  // Convert totalViews to digits array for display
  const digits = totalViews !== null && totalViews !== 'N/A' 
    ? totalViews.toString().split('') 
    : [];

  return (
    <>
      <footer className="bg-[#0b2c52] text-white text-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Logo + Social */}
          <div>
            <img src={Footerlogo} alt="Logo" className="mb-4 w-40" />
            <div className="flex space-x-4 mt-4 text-lg items-center">
              <span className="text-base">Follow Us : </span>
              <a href="https://www.facebook.com/Giffypedia/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300"><FaFacebookF /></a>
              <a href="https://x.com/giffypedia" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300"><FaTwitter /></a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Reach Us</h2>
            <p className="mb-2 flex items-start gap-2"><FaMapMarkerAlt className="mt-1" /> 27/12 Mancholai 2nd st, Ekkattuthangal,  <br/>
                 Chennai -32, Tamil Nadu, India.</p>
            <p className="mb-2 flex items-center gap-2"><FaPhoneAlt /> +91 78455 60147</p>
            <p className="mb-2 flex items-center gap-2"><FaEnvelope /> giffypedia@gmail.com</p>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Quick Links</h2>
            <ul className="space-y-2 list-disc list-inside text-white">
              <li><Link to="/support" className="hover:underline">Support</Link></li>
              <li><Link to="/privacypolicy" className="hover:underline">Privacy Policy</Link></li>
              <li><Link to="/termsandconditions" className="hover:underline">Terms & Conditions</Link></li>
              <li><Link to="/faq" className="hover:underline">FAQ</Link></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="border-t border-white/20 py-4 text-center md:text-left px-4 md:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">

            <p className="text-white text-center md:text-left">
              &copy; {currentYear} Giffypedia.com All Rights Reserved.
            </p>

            <div className="flex items-center gap-2">
              <span className="text-white mr-2">Total Views</span>
              <div className="flex space-x-1">
                {totalViews === null && <span className="text-white">Loading...</span>}
                {totalViews === 'N/A' && <span className="text-white">N/A</span>}
                {digits.map((digit, idx) => (
                  <span key={idx} className="bg-white text-black px-2 py-0.5 rounded">{digit}</span>
                ))}
              </div>
            </div>

            <p className="text-white text-center md:text-right">
              Designed & Developed By <a href="https://www.momsis.in/" target="_blank" rel="noopener noreferrer" className="font-semibold underline">Momsis Creations</a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
